import { MatPaginatorIntl } from '@angular/material/paginator';

export class CustomPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    // Customize the labels and text here
    this.itemsPerPageLabel = 'Items per page:';
    this.nextPageLabel = 'Next Page';
    this.previousPageLabel = 'Previous Page';
    this.firstPageLabel = 'First Page';
    this.lastPageLabel = 'Last Page';
    this.getRangeLabel = this.getCustomRangeLabel;
  }

  getCustomRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return `0 of ${length}`;
    }
    const startIndex = page * pageSize;
    // Clamp end index so the last page shows the real row count, e.g. "21 - 24 of 24".
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} of ${length}`;
  }
}
